import { render, staticRenderFns } from "./PeriodsDictionary.vue?vue&type=template&id=3a97852f&lang=pug&"
import script from "./PeriodsDictionary.vue?vue&type=script&lang=js&"
export * from "./PeriodsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports